'use client';

import { AccordionItem } from '../components';
import { useState } from 'react';
import { accordionItems } from '@/lib/data';

export default function Faq() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = (index) => {
    return isOpen === index ? setIsOpen(true) : setIsOpen(index);
  };
  return (
    <section className="bg-secondary-light text-ctext flex justify-center pb-16">
      <div className="lg:w-[80%] flex flex-row justify-center border-t-1 border-primary-500/25 pt-16">
        <div className="flex flex-col bg-white/50 backdrop-blur-xs shadow-sm rounded-xl px-4 py-6 gap-6 w-[80%]">
          {accordionItems.map((item, index) => (
            <AccordionItem
              homepage={true}
              key={index}
              isOpen={index === isOpen}
              question={item.question}
              answer={item.answer}
              toggle={() => toggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
